<template>
  <div class="modal csiteMenuModal reporterDetailModal authenAreaModal" id="profileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content coinModalDetailArea">
        <button type="button" class="btnClose z-3" data-bs-dismiss="modal" aria-label="Close">
          <svg class="svg-inline--fa fa-circle-xmark" aria-hidden="true" focusable="false"
            data-prefix="fas" data-icon="circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512">
            <path class="" fill="currentColor"
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z">
            </path>
          </svg>
        </button>
        <div class="modal-body p-0">
          <div class="panel-body myprofileArea custom_profile">
            <!-- <div class="d-flex justify-content-end">
              <button type="button" class="btn rounded-circle me-2 btn-warning">
                <font-awesome-icon :icon="['fas', 'pen']" /></button>
            </div> -->
            <div class="profile_bg"></div>
            <div class="row gx-4 gy-3">
              <div class="col-md-auto col">
                <div class="profileImage">
                  <img
                    src="@/assets/images/transparent/400x400.png"
                    :style="{ 'backgroundImage': `url(${memberData?.profileImage || 'image/navbar/profileIconlogin.png'})` }"
                  >
                </div>
              </div>
              <div class="col-md col-12">
                <div class="profileName text-md-start">
                <!-- {{ memberData.fullname }} -->
                {{ memberData?.fullname ?? '' }}
                <div class="text-md-start text-center">
                  <span class="badge badge-pills badge-name">{{ memberData?.displayName }}</span>  
                </div>
              </div>
            </div>
            <div class="ps-3">
              <div
                class="my-2"
                v-if="setShowEmail(memberData?.email)"
              >
                <font-awesome-icon :icon="['fas', 'envelope']" class="me-2" />
                {{ memberData?.email }}
              </div>
              <div
                class="my-2"
                v-if="memberData?.gender"
              >
              <font-awesome-icon :icon="['fas', 'venus-mars']" class="me-2" />
                เพศ: {{ getGenderText(memberData?.gender) }}
              </div>
              <div
                class="my-2"
              >
              <font-awesome-icon :icon="['fas', 'users']" class="me-2" />
                หน่วยงาน: {{ memberData?.organizationName }}
              </div>
              <div
                class="my-2"
                v-if="memberData?.role === 'admin'"
              >
              <font-awesome-icon :icon="['fas', 'user-shield']" class="me-2"/>
                ผู้ดูแลระบบ
              </div>
            </div>
            <div class="text-end">
              <button type="button" class="btn btn-outline-warning me-2" @click="editProfile">
                แก้ไขข้อมูล
              <font-awesome-icon :icon="['fas', 'pen']" class="ms-2" /></button>
              <button type="button" class="btn btn-primary" @click="signOut">
                ออกจากระบบ
                <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" class="ms-2" />
              </button>
            </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  // import zone
  import { onMounted, ref } from 'vue';
  import { useI18n } from "vue-i18n";
  import eventBus from '@/eventBus/eventBus.js';
  import { useStore } from 'vuex';

  // variable zone
  const store = useStore();
  const callApi = (param) => store.dispatch('api/apiCall',  param);
  // const memberData = ref(store.getters['auth/getMember']);
  
  const i18nLocale = useI18n();
  const dialogRef = ref(null);
  const isHideBtnBack = ref(false);
  const memberData = ref({
    _id: null,
    displayName: null,
    fullname: null,
    email: null,
    gender: null,
    organizationName: null,
    profileImage: null,
    role: null
  });

  // Function zone
  const showModal = async () => {
    await getProfileData();
    dialogRef.value?.show();
  }

  const hideModal = () => {
    dialogRef.value?.hide();
  }

  const signOut = () => {
    localStorage.removeItem('member');
    localStorage.removeItem('token');
    location.reload();
  }

  const getGenderText = (gender) => {
    if (gender === 10) {
      return 'ชาย';
    } else if (gender === 20) {
      return 'หญิง';
    }
    return 'ไม่ระบุ';
  }

  const getProfileData = async () => {
    try {
      const res = await callApi({
        svName: 'memberService',
        fnName: 'getMyProfile',
        param: {}
      });
      if (res.status === 200) {
        const tmp = res.data.result;
        memberData.value = {
          _id: tmp._id,
          displayName: tmp.displayName,
          fullname: tmp.fullname,
          email: tmp.email,
          gender: tmp.gender,
          organizationName: tmp.organizationName,
          profileImage: tmp.profileImage,
          role: tmp.role
        };
      }
    } catch (error) {
      console.log(error);
    }
  }

  const editProfile = () => {
    window.open('https://csite.thaipbs.or.th/profile', '_blank');
  }

  const setShowEmail = (email) => {
    if (email && email !== '' && !email.includes('@csitemail.com')) {
    return true;
  }
    return false;
  }
  // End function zone

  onMounted (() => {
    try {
      dialogRef.value = new bootstrap.Modal(document.getElementById('profileModal'), {});

      eventBus.on('showProfileModal', (obj) => { 
        isHideBtnBack.value = obj?.isHideBtnBack ?? false;
        showModal(); 
      });
      eventBus.on('hideProfileModal', () => { hideModal(); });
    } catch (error) {
      console.log(error);
    }
  });
  
  defineExpose({
    showModal,
    hideModal
  });
</script>